import { render } from "./Empty.vue?vue&type=template&id=3575a9ba"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"
script.render = render

export default script